<section
  scId="SC1039"
  class="container"
  *ngIf="!isLoading"
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
>
  <tmo-page-titles [pageTitle]="compareDevicesData"></tmo-page-titles>
  <div class="row">
    <div class="col-12 m-t-xl">
      <h3>{{ selectDevicesToCompare }}</h3>
      <p class="m-t-lg">{{ chooseDevicesToViewData }}</p>
    </div>
  </div>
  <div class="row tiles devices">
    <div class="col-12 m-t-md">
      <div class="tiles-container">
        <ng-container *ngFor="let item of compareDeviceData; let idx = index">
          <a
            href="javascript:void(0)"
            class="tile-item"
            [ngClass]="{ 'd-none d-md-block': idx > 2 }"
            [class.selected]="item.isChecked"
            (click)="onSelection(idx)"
          >
            <span class="tile-content"
              ><p class="small">{{ item.name }}</p></span
            ></a
          >
        </ng-container>
      </div>
    </div>
  </div>
  <hr class="divider m-t-xl" />
  <div class="row m-t-xl">
    <ng-container *ngFor="let item of selectedDevicesToCompareData; let idx = index">
      <div
        class="col-4 col-md-2 text-center"
        [class.offset-4]="idx === 0"
        [class.offset-md-2]="idx === 0"
        [ngClass]="{ 'd-none d-md-block': idx > 1 }"
        *ngIf="item.isChecked"
      >
        <img class="img-fluid browse-image" src="{{ item.imageUrl }}" alt="item.name" />
        <p class="lead m-t-lg">{{ item.name }}</p>
      </div>
    </ng-container>
  </div>
  <div class="row">
    <ng-container *ngFor="let item of selectedDevicesToCompareData; let idx = index">
      <div
        class="col-4 col-md-2 text-center"
        [class.offset-4]="idx === 0"
        [class.offset-md-2]="idx === 0"
        [ngClass]="{ 'd-none d-md-block': idx > 1 }"
        *ngIf="item.isChecked"
      >
        <p class="xsmall m-t-md">
          <tmo-star-rating
            *ngIf="item?.averageStarRating"
            [rating]="item?.averageStarRating"
            [showMiniStar]="true"
          ></tmo-star-rating>
        </p>
        <div class="xsmall m-t-xs">
          <tmo-devices-pricing-panel
            [deviceAmount]="item.price"
            [isCompare]="true"
            [id]="item.name"
          >
          </tmo-devices-pricing-panel>
        </div>
        <p class="lead xsmall m-t-xs">{{ item.withoutQualifyingPlan }}</p>
      </div>
    </ng-container>
  </div>
  <div class="specification-table m-t-xl">
    <ng-container *ngFor="let label of specificationLabel">
      <div class="row specification-row multi">
        <div class="col-4 col-md-2 specification-col">
          <p class="xsmall content p-l-sm">{{ label }}</p>
        </div>
        <ng-container *ngFor="let item of selectedDevicesToCompareData; let idx = index">
          <div
            class="col-4 col-md-2 specification-col"
            [ngClass]="{ 'd-none d-md-block': idx > 1 }"
            *ngIf="item.isChecked"
          >
            <p class="xsmall content m-r-sm">
              {{ item.deviceSpecifications[label] }}
            </p>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div class="row">
    <div class="col-12 buttons-container-vertical button-spacing-legal">
      <div class="button-box">
        <button class="btn btn-primary" (click)="returnAndNavigateBack()" id="btn-default-192">
          {{ compareDevicesContent?.return }}
        </button>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="legalText && legalText?.length > 0">
    <div class="col-12">
      <tmo-container-holder
        *ngIf="legalText"
        (pageLoadedEvent)="hideSpinner($event)"
        [isDynamicContent]="legalText"
      >
      </tmo-container-holder>
    </div>
  </div>
</section>
<!-- Spinner -->
<div *ngIf="isLoading">
  <tmo-spinner [setDelay]="!compareDeviceData"></tmo-spinner>
</div>
